import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { PillButton } from "./PillButton";

const STORAGE_KEY = "sp_cookie_consent_v1";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [showPrefs, setShowPrefs] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) setVisible(true);
    const opener = () => {
      setShowPrefs(true);
      setVisible(true);
    };
    window.addEventListener("open-cookie-preferences", opener);
    return () => window.removeEventListener("open-cookie-preferences", opener);
  }, []);

  const save = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ necessary: true, analytics: choice, ts: Date.now() })
    );
    setVisible(false);
    setShowPrefs(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 inset-x-0 z-[60] px-4 pb-4 md:px-6 md:pb-6"
          data-testid="cookie-banner"
        >
          <div className="max-w-5xl mx-auto bg-sand border border-border rounded-2xl shadow-[0_12px_40px_rgb(0,0,0,0.08)] p-6 md:p-8">
            <div className="md:flex md:items-start md:gap-8">
              <div className="flex-1">
                <h4 className="font-serif text-2xl text-ink">Rispetto della tua privacy</h4>
                <p className="mt-2 text-sm text-stone leading-relaxed max-w-2xl">
                  Utilizziamo cookie tecnici necessari al funzionamento del sito. Con il tuo consenso
                  potremmo utilizzare cookie di analisi. Nessun cookie non necessario è attivo senza il
                  tuo consenso esplicito. Maggiori dettagli nella{" "}
                  <Link to="/privacy#cookie" className="text-sage-dark underline underline-offset-2">
                    Cookie Policy
                  </Link>
                  .
                </p>

                {showPrefs && (
                  <div className="mt-5 space-y-3">
                    <label className="flex items-center gap-3 text-sm text-ink opacity-70">
                      <input type="checkbox" checked readOnly className="accent-sage h-4 w-4" data-testid="cookie-necessary" />
                      Cookie necessari (sempre attivi)
                    </label>
                    <label className="flex items-center gap-3 text-sm text-ink cursor-pointer">
                      <input
                        type="checkbox"
                        checked={analytics}
                        onChange={(e) => setAnalytics(e.target.checked)}
                        className="accent-sage h-4 w-4"
                        data-testid="cookie-analytics"
                      />
                      Cookie di analisi (facoltativi, non preselezionati)
                    </label>
                  </div>
                )}
              </div>

              <div className="mt-6 md:mt-0 flex flex-col sm:flex-row md:flex-col gap-3 shrink-0">
                <PillButton onClick={() => save(true)} testid="cookie-accept" className="whitespace-nowrap">
                  Accetta tutti
                </PillButton>
                <PillButton onClick={() => save(false)} variant="outline" testid="cookie-reject" className="whitespace-nowrap">
                  Solo necessari
                </PillButton>
                {!showPrefs && (
                  <button
                    onClick={() => setShowPrefs(true)}
                    className="text-sm text-stone hover:text-ink transition-colors underline underline-offset-2"
                    data-testid="cookie-customize"
                  >
                    Personalizza
                  </button>
                )}
                {showPrefs && (
                  <PillButton onClick={() => save(analytics)} variant="ghost" testid="cookie-save-prefs" className="whitespace-nowrap">
                    Salva preferenze
                  </PillButton>
                )}
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
